export function isSaoJoao() {
  return new Date().getMonth() === 5;
}
